import { createContext } from "react";

import {
  FileSortKey,
  FileStatus,
  type LibraryFile,
  LibraryFolder,
  SortDirection,
} from "./types";

export type ILibraryPageContext = {
  folders: LibraryFolder[];
  allFiles: LibraryFile[];
  displayedFiles: LibraryFile[];
  selectedViewId: FileStatus | null;
  setSelectedViewId: (value: FileStatus | null) => void;
  selectedFolderName: string | undefined;
  setSelectedFolderName: (value: string) => void;
  refetchFolders: () => Promise<any>;
  isFetchingFolders: boolean;
  isFetchingFiles: boolean;
  refetchFiles: () => Promise<unknown>;
  searchValue: string;
  setSearchValue: (value: string) => void;
  sortKey: FileSortKey;
  setSortKey: (value: FileSortKey) => void;
  sortDirection: SortDirection;
  setSortDirection: (value: SortDirection) => void;
  createFolder: ({
    terminalId,
    folderName,
  }: {
    terminalId: string;
    folderName: string;
  }) => void;
};

export const LibraryPageContext = createContext({
  folders: [],
  allFiles: [],
  displayedFiles: [],
  selectedViewId: FileStatus.PUBLISHED,
  setSelectedViewId: () => {},
  selectedFolderName: undefined,
  setSelectedFolderName: () => {},
  refetchFolders: async () => {},
  isFetchingFolders: false,
  isFetchingFiles: false,
  refetchFiles: async () => {},
  searchValue: "",
  setSearchValue: () => {},
  sortKey: FileSortKey.DATE,
  setSortKey: () => {},
  sortDirection: SortDirection.DESC,
  setSortDirection: () => {},
  createFolder: () => {},
} as ILibraryPageContext);
